import { useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { useOrg } from '../context/OrgContext';
import {
  Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter,
} from './ui/dialog';
import { Button } from './ui/button';
import {
  Select, SelectContent, SelectItem, SelectTrigger, SelectValue,
} from './ui/select';
import { Share2, Loader2 } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/** Copy selected companies/contacts from HQ into an isolated sub-account. */
export const ShareToOrgDialog = ({ objectType, ids, open, onOpenChange, onDone }) => {
  const { orgs } = useOrg();
  const [orgId, setOrgId] = useState('');
  const [sharing, setSharing] = useState(false);

  const share = async () => {
    if (!orgId) { toast.error('Pick a sub-account'); return; }
    setSharing(true);
    try {
      const res = await axios.post(`${API}/organisations/${orgId}/share`, { object_type: objectType, ids });
      toast.success(`Shared ${res.data.shared} ${objectType === 'company' ? 'companies' : 'contacts'} to ${res.data.org_name}`);
      onOpenChange(false);
      if (onDone) onDone();
    } catch (err) {
      toast.error(err.response?.data?.detail || 'Share failed');
    } finally { setSharing(false); }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="bg-slate-900 border-slate-800" data-testid="share-to-org-dialog">
        <DialogHeader>
          <DialogTitle className="text-white flex items-center gap-2"><Share2 className="w-5 h-5 text-violet-400" /> Share {ids.length} {objectType === 'company' ? 'companies' : 'contacts'}</DialogTitle>
          <DialogDescription className="text-slate-400">Copy the selected records into an isolated supplier sub-account. Contacts keep their company link.</DialogDescription>
        </DialogHeader>
        <div className="space-y-2">
          <Select value={orgId} onValueChange={setOrgId}>
            <SelectTrigger className="bg-slate-950 border-slate-800" data-testid="share-org-select"><SelectValue placeholder="Choose a sub-account" /></SelectTrigger>
            <SelectContent className="bg-slate-900 border-slate-800">
              {orgs.map((o) => <SelectItem key={o.id} value={o.id}>{o.name}</SelectItem>)}
            </SelectContent>
          </Select>
        </div>
        <DialogFooter>
          <Button variant="ghost" onClick={() => onOpenChange(false)}>Cancel</Button>
          <Button className="bg-violet-600 hover:bg-violet-700 text-white" onClick={share} disabled={sharing} data-testid="share-confirm-btn">
            {sharing ? <Loader2 className="w-4 h-4 mr-2 animate-spin" /> : <Share2 className="w-4 h-4 mr-2" />} Share
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
